import { faLocationDotSlash } from '@fortawesome/pro-regular-svg-icons'

import { EmptyState, FormattedMessage } from '@b-stock/fe-core/bstock-react'

const ns = 'Listing.errors.geofenceRestricted'

export const GeofenceRestrictedErrorBanner = () => {
  return (
    <EmptyState
      icon={faLocationDotSlash}
      title={<FormattedMessage id={`${ns}.title`} />}
      description={<FormattedMessage id={`${ns}.description`} />}
      size={4}
    />
  )
}
